import { Balance } from '@/features/Wallets/wallet.types'
import { profileService } from '@/services'
import { sortByKey } from '@/shared/helpers/array'
import { useBalancesStore } from '@/store'
import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'

export async function getUserBalances () {
  const response = await profileService.getBalances()
  const sorted = sortByKey<Balance>(response.wallets, 'isMain')
  const setSelectedWallet = useBalancesStore.getState().setSelectedWallet

  const mainWallet = response.wallets.find((balance) => balance.isMain)
  if (mainWallet) {
    setSelectedWallet(mainWallet.address, mainWallet.name)
  } else if (response.wallets[0]) {
    setSelectedWallet(response.wallets[0].address, response.wallets[0].name)
  }

  return sorted
}

export const balancesQueryKey = ['balances'] as const

export const createBalancesQueryOptions = (enabled: boolean = true) => queryOptions({
  queryKey: balancesQueryKey,
  enabled: enabled,
  queryFn: getUserBalances,
  staleTime: 1000 * 60 * 5,
  gcTime: 0,
  refetchOnWindowFocus: true,
  refetchInterval: 0,
  refetchIntervalInBackground: false,
})

export function useSetMainWallet() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (address: string) => profileService.setMainWallet(address),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: balancesQueryKey })
    },
  })
}
